export const subtitles = {
    "1": {
        "startTime": 0.0,
        "endTime": 2.0,
        "transcript": "Tangvaglua… wait.",
        "translation": "Watch me… wait."
    },
    "2": {
        "startTime": 3.0,
        "endTime": 5.0,
        "transcript": "Tangvaglua piniartuten.",
        "translation": "Watch me as you [speak]."
    },
    "3": {
        "startTime": 7.0,
        "endTime": 8.0,
        "transcript": "Wait.",
        "translation": "Wait."
    },
    "4": {
        "startTime": 27.0,
        "endTime": 29.0,
        "transcript": "Tuar tanqiggall'.",
        "translation": "It seems a little bright."
    },
    "5": {
        "startTime": 30.0,
        "endTime": 32.0,
        "transcript": "Aren-qaa assirtuq?",
        "translation": "Or is it good?"
    },
    "6": {
        "startTime": 34.0,
        "endTime": 36.0,
        "transcript": "Tanqigngatuq.",
        "translation": "It looks bright."
    },
    "7": {
        "startTime": 36.5,
        "endTime": 38.0,
        "transcript": "Ayagceteksaitan-qaa?",
        "translation": "Have started it yet?"
    },
    "8": {
        "startTime": 39.0,
        "endTime": 39.9,
        "transcript": "Yaa, uitaqaa.",
        "translation": "Yes, hold on."
    },
    "9": {
        "startTime": 40.0,
        "endTime": 52.0,
        "transcript": "Kitak' ayagceskuvgu apeskia qaill' uksuarmi up'ngelauciit atu'urkameggnek.",
        "translation": "Now, when you start it, ask me how they started getting ready in the fall for what they would need to use."
    },
    "10": {
        "startTime": 57.0,
        "endTime": 58.9,
        "transcript": "Tuaten aqumgaciquten?",
        "translation": "Will you be sitting like that?"
    },
    "11": {
        "startTime": 59.0,
        "endTime": 62.0,
        "transcript": "Ii-i, waten aqumgaurciqua.",
        "translation": "Yes, I will be sitting like this."
    },
    "12": {
        "startTime": 68.0,
        "endTime": 73.0,
        "transcript": "Kitak' qaillun up'ngellruat waten uksumek?",
        "translation": "Now, how did they get ready for the winter like this?"
    },
    "13": {
        "startTime": 75.0,
        "endTime": 83.0,
        "transcript": "Waten-qaa uksuarmi up'ngelallrit au͡gkut?",
        "translation": "You mean how people long ago got ready for the fall like this?"
    },
    "14": {
        "startTime": 83.5,
        "endTime": 84.5,
        "transcript": "Yaa.",
        "translation": "Yes."
    },
    "15": {
        "startTime": 85.0,
        "endTime": 88.0,
        "transcript": "Au͡gkut ciuqlimta?",
        "translation": "Our ancestors back then?"
    },
    "16": {
        "startTime": 88.5,
        "endTime": 89.5,
        "transcript": "Yaa.",
        "translation": "Yes."
    },
    "17": {
        "startTime": 90.0,
        "endTime": 101.0,
        "transcript": "Tua-i-llu wiinga waniw' ak'allauqapiaraunritua",
        "translation": "And so, I'm not extremely old"
    },
    "18": {
        "startTime": 103.0,
        "endTime": 110.0,
        "transcript": "Tau͡gaam maa-i allrakunka 68-aarurrluteng.",
        "translation": "But I am now 68 years old."
    },
    "19": {
        "startTime": 113.0,
        "endTime": 115.9,
        "transcript": "Tuntutuliarmiungulua.",
        "translation": "I am from Tuntutuliak."
    },
    "20": {
        "startTime": 116.9,
        "endTime": 121.0,
        "transcript": "Yugtun-llu atengqerrlua Ackiarmek pilallruatnga.",
        "translation": "I have a Yup'ik name, Ackiar, that they called me."
    },
    "21": {
        "startTime": 122.0,
        "endTime": 127.5,
        "transcript": "Tua-i-ll' Kassaurcamta maa-i Nick Lupie-mek pilanglua.",
        "translation": "An then when we became Westernized now, they started calling me Nick Lupie."
    },
    "22": {
        "startTime": 128.0,
        "endTime": 137.9,
        "transcript": "Tua-i-llu ava-i aptuten uksuarmi up'ngelallritnek",
        "translation": "And so, you just asked how they got ready in the fall"
    },
    "23": {
        "startTime": 138.0,
        "endTime": 148.0,
        "transcript": "Wall'u uksum-wa tua-i atu'urkainek up'ngelallritnek.",
        "translation": "Or, how they got ready for what they would need to use in the winter."
    },
    "24": {
        "startTime": 149.0,
        "endTime": 159.5,
        "transcript": "Wii tua-i nallunrilkemnek tangvallemnek-llu, yaa, waniw' qanengssakatartua.",
        "translation": "Now, I'm going to start talking, yes, about things I know and have seen."
    },
    "25": {
        "startTime": 160.0,
        "endTime": 168.0,
        "transcript": "Waten uksuarmi qavani Kialirmi tan'gaurluullemteńi",
        "translation": "Upriver in Kialiq in the fall like this when we were boys"
    },
    "26": {
        "startTime": 169.0,
        "endTime": 176.0,
        "transcript": "Kiani Kialiim paingani Qukaqlircaramek-gguq uumek aterluni kuiggaq au͡gna.",
        "translation": "Upriver at the mouth of Kialiq, they say that that creek is called Qukaqlircaraq."
    },
    "27": {
        "startTime": 176.5,
        "endTime": 180.0,
        "transcript": "Tuani tua-i uitalallruukut.",
        "translation": "We used to stay there."
    },
    "28": {
        "startTime": 181.0,
        "endTime": 191.0,
        "transcript": "Makut tau͡gken aulukesteput waten uksuarmi uitaurallrunritut.",
        "translation": "Our caretakers here, however, were not sedentary in the fall like this."
    },
    "29": {
        "startTime": 194.0,
        "endTime": 200.0,
        "transcript": "Wall'u cali uitaurluteng waten ayagayuitellruluteng.",
        "translation": "Or, they didn't travel without working like this either."
    },
    "30": {
        "startTime": 201.0,
        "endTime": 207.9,
        "transcript": "Makut maa-i uksuarmun atulriit",
        "translation": "These things that are used for the fall"
    },
    "31": {
        "startTime": 209.0,
        "endTime": 220.0,
        "transcript": "Waten agaaken neqlillernek taigaqameng uksuarmi muragnek quyurtetullruut.",
        "translation": "When they came from fish camps across there in the fall, they would gather wood."
    },
    "32": {
        "startTime": 221.0,
        "endTime": 225.9,
        "transcript": "Angyaunateng-llu, tau͡gaam qayatgun.",
        "translation": "And they didn't have boats, only kayaks."
    },
    "33": {
        "startTime": 226.0,
        "endTime": 233.0,
        "transcript": "Unuakumi waten uksuarmi ulerpagangetuan",
        "translation": "In the morning in the fall like this, because the tide gets very high"
    },
    "34": {
        "startTime": 234.0,
        "endTime": 240.0,
        "transcript": "Unuakuarmi tan'germi tayima ayagangtullruut.",
        "translation": "They would start traveling in the early morning when it was dark."
    },
    "35": {
        "startTime": 241.0,
        "endTime": 250.0,
        "transcript": "Tua-i tau͡gken iliini uaggun Cingigkun igvarnaurtuq iliini qayaq.",
        "translation": "Yet sometimes, a kayak would sometimes come into view from Cingik downriver."
    },
    "36": {
        "startTime": 250.5,
        "endTime": 252.0,
        "transcript": "Nangcarluni muragnek.",
        "translation": "It would be pulling [a cargo of] wood."
    },
    "37": {
        "startTime": 255.0,
        "endTime": 266.9,
        "transcript": "Tua-i tamaa-i tamakut waten uksuarmi maavet kuiget kangritnun ayakata'arqameng",
        "translation": "Those people in the fall like this, when they were going to go to the headwaters of these rivers"
    },
    "38": {
        "startTime": 267.0,
        "endTime": 273.0,
        "transcript": "Uksuiyaqatarqameng tamakunek tamaa-i quyurtetullruut.",
        "translation": "They would gather those when they were going to go to winter camps."
    },
    "39": {
        "startTime": 276.0,
        "endTime": 285.0,
        "transcript": "Au͡gkut ciuqliput anglicarteput wangkucicetun maanitun ayuqellrunritut.",
        "translation": "Our elders who raised us were not like how we are here."
    },
    "40": {
        "startTime": 286.0,
        "endTime": 293.9,
        "transcript": "Ellmeggnek ang'aqualuteng tallimegteggun ayagaluteng",
        "translation": "They would travel rowing with their own arms"
    },
    "41": {
        "startTime": 294.0,
        "endTime": 298.0,
        "transcript": "Merkun anguarturluteng pitullruut.",
        "translation": "Rowing [kayaks] on the water."
    },
    "42": {
        "startTime": 299.0,
        "endTime": 308.0,
        "transcript": "Tua-i-llu nutaan pinarilliateng asgurangluteng",
        "translation": "And when it was time, they would start going upriver"
    },
    "43": {
        "startTime": 310.0,
        "endTime": 314.9,
        "transcript": "Imkut tamakut muriit itulluki.",
        "translation": "Bringing those pieces of wood with them."
    },
    "44": {
        "startTime": 317.0,
        "endTime": 323.0,
        "transcript": "Nutaan-llu qaingit canek ucilirluki aklumeggnek.",
        "translation": "And they would then load their possessions on top of them."
    },
    "45": {
        "startTime": 324.0,
        "endTime": 329.0,
        "transcript": "Angyailnguut muragteggun tua-i upatullruut.",
        "translation": "Those without boats would relocate using wood."
    },
    "46": {
        "startTime": 330.0,
        "endTime": 340.9,
        "transcript": "Tua-i-llu nutaan tekicameng kuiget kangritnun tamaavet uksuillerkameggnun muriit tamakut tageqluki.",
        "translation": "And then when they reached the headwaters of those rivers where they would spend the winter, they would bring up those pieces of wood."
    },
    "47": {
        "startTime": 341.0,
        "endTime": 355.9,
        "transcript": "Nutaan-llu upluteng muriit tamakut neqsuutekateng taluyarkateng upluki.",
        "translation": "They would then prepare the wood, preparing their fish traps that they used to catch fish."
    },
    "48": {
        "startTime": 360.0,
        "endTime": 367.0,
        "transcript": "Anglicarteput au͡gkut nangtequaluteng pitullruut.",
        "translation": "Those who raised us back then used to struggle."
    },
    "49": {
        "startTime": 368.0,
        "endTime": 375.0,
        "transcript": "Muriit imkut taluyarkiurluki, taluyarpagkiurluki pitullruit.",
        "translation": "They used to prepare that wood to make fish traps, big fish traps."
    },
    "50": {
        "startTime": 376.0,
        "endTime": 383.9,
        "transcript": "Waten taluyarpiit ayuqetullruut. Paingit.",
        "translation": "Big fish traps were like this. Their openings."
    },
    "51": {
        "startTime": 384.0,
        "endTime": 386.0,
        "transcript": "Iqtuluteng, takluteng.",
        "translation": "They were wide, [and] long."
    },
    "52": {
        "startTime": 389.0,
        "endTime": 394.0,
        "transcript": "Waten-llu tua-i piluteng, ayuqluteng.",
        "translation": "And then they were like this."
    },
    "53": {
        "startTime": 394.9,
        "endTime": 396.9,
        "transcript": "Wagg'uq taukut tua-i ilulirpait.",
        "translation": "They called those their inner compartments [ilulirpiit]."
    },
    "54": {
        "startTime": 397.0,
        "endTime": 405.9,
        "transcript": "Nutaan-llu ukut cali qukait cali taluyiluki waten qerrurluki.",
        "translation": "And they would then make fish traps out of the centers too, inflating them like this."
    },
    "55": {
        "startTime": 406.0,
        "endTime": 411.0,
        "transcript": "Nutaan-llu yaaggun pingayuat piluku.",
        "translation": "And they would then put the third over there."
    },
    "56": {
        "startTime": 412.0,
        "endTime": 419.0,
        "transcript": "Tamakut tamaa-i qamunek pitullruit taluyapiat.",
        "translation": "They used to call those old fish traps qamut."
    },
    "57": {
        "startTime": 419.5,
        "endTime": 427.0,
        "transcript": "Makut taluyarpiit pitun, can'giircuutetun ayuqellrunritut.",
        "translation": "This fish traps were not like, you know, blackfish traps."
    },
    "58": {
        "startTime": 428.0,
        "endTime": 431.0,
        "transcript": "Waten-llu iciw' akultutaluteng.",
        "translation": "You know, they were this far apart."
    },
    "59": {
        "startTime": 431.5,
        "endTime": 434.0,
        "transcript": "Akultutarrluki.",
        "translation": "They made them equidistant."
    },
    "60": {
        "startTime": 435.0,
        "endTime": 439.0,
        "transcript": "Yaa, piciatun-am pivkenaki tamakut taluyarpiit pitullruit.",
        "translation": "Yes, they didn't make those big fish traps haphazardly."
    },
    "61": {
        "startTime": 440.0,
        "endTime": 444.5,
        "transcript": "Waten ukut cuq'errluki.",
        "translation": "They measured these."
    },
    "62": {
        "startTime": 445.0,
        "endTime": 451.0,
        "transcript": "Tua-i-llu imna cigyak elliluku, tuavet elliluku.",
        "translation": "And then they put that split spruce there."
    },
    "63": {
        "startTime": 451.5,
        "endTime": 455.9,
        "transcript": "Tua-i-ll' waten nutaan pirraarluku yaatiinun",
        "translation": "And then after doing this over from it"
    },
    "64": {
        "startTime": 456.0,
        "endTime": 461.0,
        "transcript": "Qaill' tua-i waten akultutarrluki tamakut taluyarpiit pitullruit.",
        "translation": "They used to make those big fish traps about this far from each other like this."
    },
    "65": {
        "startTime": 464.0,
        "endTime": 471.0,
        "transcript": "Tua-i waten caliaqengaqamegteki unatmeggnek-llu nangutetullruut.",
        "translation": "When they started working on them like this their hands would become raw."
    },
    "66": {
        "startTime": 472.0,
        "endTime": 478.0,
        "transcript": "Makut ukut waten piurallrit pelacinagnek piyuunaki.",
        "translation": "These parts made like this were not made with twine."
    },
    "67": {
        "startTime": 479.0,
        "endTime": 487.0,
        "transcript": "Tau͡gaam makunek cali muragnek qupurturluki amililuki, mamkunaki.",
        "translation": "Instead, they thinly split these pieces of wood."
    },
    "68": {
        "startTime": 488.0,
        "endTime": 493.5,
        "transcript": "Qaillun tua-i waten iqtutaurluki, tau͡gaam amililuki.",
        "translation": "They made them about this wide, but thin."
    },
    "69": {
        "startTime": 494.0,
        "endTime": 498.9,
        "transcript": "Tamakut-am tua-i piciatun cali caliaqsuitellruit.",
        "translation": "They wouldn't work on those haphazardly either."
    },
    "70": {
        "startTime": 499.0,
        "endTime": 504.0,
        "transcript": "Cuqerluteng qaillun mamtutacirkait.",
        "translation": "Their thicknesses had [set] measurements."
    },
    "71": {
        "startTime": 506.0,
        "endTime": 514.0,
        "transcript": "Tuaten tua-i pingaqameng makuit nangtullruut ukut waten piurluki.",
        "translation": "When they started doing that, their [hands] here would get raw doing this."
    },
    "72": {
        "startTime": 515.0,
        "endTime": 527.0,
        "transcript": "Aunrangaqata tua-i imkunek qecignek caquliluki ukut pingayun pitullruit",
        "translation": "When they started bleeding, they would wrap these three with hide"
    },
    "73": {
        "startTime": 529.0,
        "endTime": 531.0,
        "transcript": "Nang'aqata makut.",
        "translation": "When these got raw."
    },
    "74": {
        "startTime": 533.0,
        "endTime": 538.5,
        "transcript": "Ukut-llu cali, ukut-llu nang'aqluteng tegumiaqurallrit.",
        "translation": "And these, these would also get raw where they held them."
    },
    "75": {
        "startTime": 540.0,
        "endTime": 547.0,
        "transcript": "Au͡gkut, ciuqliput-wa tua-i wangkucicetun waten ayuqellrunritut.",
        "translation": "Our ancestors back then were not like this as we are."
    },
    "76": {
        "startTime": 548.0,
        "endTime": 553.5,
        "transcript": "Aklungqellruut, muragnek aklungqellruut.",
        "translation": "They had possessions, wooden possessions."
    },
    "77": {
        "startTime": 553.6,
        "endTime": 561.0,
        "transcript": "Tamaa-i tamakut aklukellruit muriit, cassuutekluki.",
        "translation": "They used wood to make possessions, tools."
    },
    "78": {
        "startTime": 561.5,
        "endTime": 572.9,
        "transcript": "Una cakluki, enekluki, enemeggnun waten aklukluki, ikamraqluki-llu.",
        "translation": "They used it for things, houses, possessions for their houses, and sleds."
    },
    "79": {
        "startTime": 573.0,
        "endTime": 580.5,
        "transcript": "Tua-i cat, aturluku una murak yuungnaqellruut, muriit.",
        "translation": "They survived using this wood for things."
    },
    "80": {
        "startTime": 585.0,
        "endTime": 599.5,
        "transcript": "Tua-i tau͡gken cali civcimariaqamegteki nutaan waten unuaquaqan takuurluki",
        "translation": "And yet when they started getting set, they would check them every day"
    },
    "81": {
        "startTime": 603.0,
        "endTime": 608.0,
        "transcript": "Unuakumi-llu cali uicara'arluteng ullraarluni entaqan.",
        "translation": "And they would wake up early in the morning when the tide goes out after it came in."
    },
    "82": {
        "startTime": 611.0,
        "endTime": 626.0,
        "transcript": "Unugmi tua-i makluteng imkut neqsuuteteng kapuyutait, atrarluteng menglait waten tugqerraarluki kaputkaniraqluki.",
        "translation": "They would get up at night, [check on] their fishing tools' stakes, go down, and drive them deeper after picking the ice around them like this."
    },
    "83": {
        "startTime": 627.0,
        "endTime": 633.0,
        "transcript": "Au͡gkut ava-i waten aulukesteput ayuqellruut.",
        "translation": "That is what our caretakers back then were like."
    },
    "84": {
        "startTime": 634.0,
        "endTime": 637.5,
        "transcript": "Mat'um nalliinitun ayuqevkenateng.",
        "translation": "They weren't like how it is now."
    },
    "85": {
        "startTime": 639.0,
        "endTime": 644.5,
        "transcript": "Tua-llu nutaan uksuarmi tuaten tua-i pian",
        "translation": "And then in the fall when it was time."
    },
    "86": {
        "startTime": 645.0,
        "endTime": 652.5,
        "transcript": "Makut cali arnaita aklukaitnek upluki, atu'urkaitnek.",
        "translation": "Their women would prepare tools that they would use."
    },
    "87": {
        "startTime": 656.0,
        "endTime": 660.0,
        "transcript": "Makunek tua-i imkunek neqnek, taryaqviit-llu qeciitnek",
        "translation": "The skins of these fish, including king salmon"
    },
    "88": {
        "startTime": 666.0,
        "endTime": 668.9,
        "transcript": "Wagg'uq amiraliluki.",
        "translation": "They called it preparing fish skins for clothes."
    },
    "89": {
        "startTime": 669.0,
        "endTime": 672.9,
        "transcript": "Amiragnek tamakut pitullruit neqet qeciit.",
        "translation": "They referred to those fish skins as amiriit."
    },
    "90": {
        "startTime": 674.0,
        "endTime": 675.9,
        "transcript": "Kitak' uitaqaa.",
        "translation": "Hold on."
    },
    "91": {
        "startTime": 690.0,
        "endTime": 692.5,
        "transcript": "Kitak' nutaan.",
        "translation": "Now, start again."
    },
    "92": {
        "startTime": 693.5,
        "endTime": 695.5,
        "transcript": "Ayagnirnariuq? Ii-i.",
        "translation": "It's time to start? Okay."
    },
    "93": {
        "startTime": 696.0,
        "endTime": 701.5,
        "transcript": "Ava-i au͡gna, au͡gkut ava-i waten qanengssakellrenka",
        "translation": "Those things I just talked about like this"
    },
    "94": {
        "startTime": 702.0,
        "endTime": 711.5,
        "transcript": "Angutet caliarit, angutet calilallrit aklumeggnek upluteng pillret.",
        "translation": "Men's work, how men worked to prepare their tools."
    },
    "95": {
        "startTime": 712.0,
        "endTime": 716.0,
        "transcript": "Tau͡gken cali makut arnat allakarmeng.",
        "translation": "However, these women would [work] separately."
    },
    "96": {
        "startTime": 718.0,
        "endTime": 728.5,
        "transcript": "Waten cikuvailgan-llu uptenglallruit anguteteng atu'urkaitnek, pilugugkaitnek.",
        "translation": "And before it froze like this, they would prepare tools and skin boots for their men."
    },
    "97": {
        "startTime": 730.0,
        "endTime": 738.0,
        "transcript": "Makunek-llu cali waten neqet qeciitnek, taryaqvagnek",
        "translation": "And these fish skins like this, king salmon [skins]"
    },
    "98": {
        "startTime": 740.0,
        "endTime": 743.0,
        "transcript": "Apeqmeggnek-gguq neqairiluteng.",
        "translation": "They would call it neqairiluteng."
    },
    "99": {
        "startTime": 743.5,
        "endTime": 747.5,
        "transcript": "Tuaten pitullruut amiragkiurqamegteki.",
        "translation": "That's what they would do when they prepared fish skins for clothes."
    },
    "100": {
        "startTime": 748.0,
        "endTime": 758.5,
        "transcript": "Cali-am tamakut waten tua-i kemgit au͡g'aqainarraarpek'naki.",
        "translation": "Also, they wouldn't just stop at removing the flesh."
    },
    "101": {
        "startTime": 759.5,
        "endTime": 769.0,
        "transcript": "Taqngamegteki tamakut kemgit au͡gaumariaqata egmianun cali caliaqevkenaki.",
        "translation": "When they were finished removing their flesh, they wouldn't work on them right away."
    },
    "102": {
        "startTime": 770.0,
        "endTime": 780.5,
        "transcript": "Waten cali teq'umun akurrluki pitullruit tamakut neqet qeciit.",
        "translation": "They also used to submerge those fish skins into urine like this."
    },
    "103": {
        "startTime": 783.5,
        "endTime": 785.5,
        "transcript": "Neqcugniirulluki.",
        "translation": "They removed the smell of fish."
    },
    "104": {
        "startTime": 786.0,
        "endTime": 792.5,
        "transcript": "Makut maa-i waten wagg'uq teq'iciriaqameng",
        "translation": "When they did this, what they called aging urine"
    },
    "105": {
        "startTime": 795.0,
        "endTime": 806.5,
        "transcript": "Cat, canun tua-i assigtaitnun, nutem assigtaitnun angutait tamaavet qurrmatullruut.",
        "translation": "Their men would urinate into those containers, their original containers."
    },
    "106": {
        "startTime": 807.0,
        "endTime": 809.5,
        "transcript": "Wagg'uq teq'iciriluteng.",
        "translation": "They called that aging urine."
    },
    "107": {
        "startTime": 810.0,
        "endTime": 813.0,
        "transcript": "Tua-i tepsaqnaurtut tamakut cakneq.",
        "translation": "Those would be very stinky."
    },
    "108": {
        "startTime": 814.0,
        "endTime": 821.0,
        "transcript": "Tua-i tamakunun akurrluki tamakut neqet qeciit pitullruit.",
        "translation": "They used to soak fish skins in those."
    },
    "109": {
        "startTime": 822.0,
        "endTime": 828.5,
        "transcript": "Nutaan-llu tua-i akungqarraarluki keligarluki.",
        "translation": "And after they were soaked, they would then scrape them."
    },
    "110": {
        "startTime": 829.0,
        "endTime": 832.0,
        "transcript": "Keligaucirluki ayallanun pirraarluki.",
        "translation": "They would scrape them after putting them on boards."
    },
    "111": {
        "startTime": 832.5,
        "endTime": 839.0,
        "transcript": "Nutaan ellamun agarrluki kinercirluki.",
        "translation": "They would then hang them outside to dry."
    },
    "112": {
        "startTime": 839.5,
        "endTime": 852.0,
        "transcript": "Tua-i-llu nutaan kinraki tamakut tamaa-i tamakunun angutmeggnun piluguliluki.",
        "translation": "And then when those dried, they would make those into boots for their men."
    },
    "113": {
        "startTime": 852.5,
        "endTime": 857.5,
        "transcript": "Wagg'uq amiraliluki waten ayagassuucirluki.",
        "translation": "They called that making them fish skin [clothes] that they would use to travel like this."
    },
    "114": {
        "startTime": 859.0,
        "endTime": 862.5,
        "transcript": "Makut cali angutait cali upluteng",
        "translation": "Their men would also prepare."
    },
    "115": {
        "startTime": 865.0,
        "endTime": 868.0,
        "transcript": "Imkunek can'giircuutnek cali.",
        "translation": "Even those blackfish traps."
    },
    "116": {
        "startTime": 869.0,
        "endTime": 873.0,
        "transcript": "Tamakut pinriata imkut taluyarpagnek pitullriit",
        "translation": "When stopped using what they called big fish traps"
    },
    "117": {
        "startTime": 874.0,
        "endTime": 892.5,
        "transcript": "Makunek maa-i can'giirnek cali cimiqata'arqamegteki nutaan tamakunek call' taluyiluteng pitullruut.",
        "translation": "When they were going to change those for blackfish too, they would also make those fish traps."
    },
    "118": {
        "startTime": 897.0,
        "endTime": 902.9,
        "transcript": "Tua-i-llu nutaan cali civcimariitki",
        "translation": "And then when they kept them set"
    },
    "119": {
        "startTime": 904.0,
        "endTime": 917.0,
        "transcript": "Maa-i mat'um nalliini canek can'giiret waten assigtalaraput piciatun yaassiillernek missuullernek-llu.",
        "translation": "These days, we use various things, boxes and sacks to put blackfish in."
    },
    "120": {
        "startTime": 918.5,
        "endTime": 926.9,
        "transcript": "Tau͡gken au͡gkut murilkellrenka anglicartelput tamakunek pitaitellruut.",
        "translation": "However, those who raised us back then that I observed didn't have those."
    },
    "121": {
        "startTime": 928.0,
        "endTime": 940.5,
        "transcript": "Makut maa-i arnait cali tamakunek canegnek caqukaitnek uptetullruut.",
        "translation": "Their women also used to prepare grass to put them in."
    },
    "122": {
        "startTime": 941.0,
        "endTime": 947.0,
        "transcript": "Waten tua-i, yaa, cungakvaunrirqata, qakingaqaki",
        "translation": "Like this, yes, when they're not green anymore, when they're getting pale"
    },
    "123": {
        "startTime": 948.0,
        "endTime": 951.0,
        "transcript": "Amlleriluki waten quyurrluki.",
        "translation": "They would gather a lot like this."
    },
    "124": {
        "startTime": 956.0,
        "endTime": 958.0,
        "transcript": "Cali-llu waten kiagmi…",
        "translation": "And in the summer like this..."
    },
    "125": {
        "startTime": 959.5,
        "endTime": 961.0,
        "transcript": "Kituriqalliniunga.",
        "translation": "I forgot something."
    },
    "126": {
        "startTime": 962.0,
        "endTime": 970.5,
        "transcript": "Uptelallruit arnat tamakut pikameggnek tamakut can'get kelugkaitnek.",
        "translation": "Women would prepare that grass, coarse grass, for their things."
    },
    "127": {
        "startTime": 971.0,
        "endTime": 974.5,
        "transcript": "Kelugkaitnek-wa tua-i pissuutekaitnek.",
        "translation": "They would be used for weaving."
    },
    "128": {
        "startTime": 977.0,
        "endTime": 988.9,
        "transcript": "Au͡gkut anglicartelput ingna tekitarkaq waten umyuaqerrlainarluku pitullruut.",
        "translation": "Those who raised us back then always kept the future in mind."
    },
    "129": {
        "startTime": 989.0,
        "endTime": 996.0,
        "transcript": "Ingna tekitarkaq atu'urkateng yaaqsingraan upyuterrlainarluku",
        "translation": "They always prepared what they would need in the future even if it was a long way off"
    },
    "130": {
        "startTime": 997.0,
        "endTime": 998.9,
        "transcript": "Camek-wa tua-i piilameng.",
        "translation": "Because they didn't have anything [pre-made]."
    },
    "131": {
        "startTime": 999.0,
        "endTime": 1005.5,
        "transcript": "Maani tau͡gaam makunek nunam qainganelngurnek aklungqellruut.",
        "translation": "They only had what [was made from] the land."
    },
    "132": {
        "startTime": 1007.0,
        "endTime": 1012.5,
        "transcript": "Tua-i pinricunaunateng tamakut ellaitni piaqluteng.",
        "translation": "They would [work] because they couldn't afford not to."
    },
    "133": {
        "startTime": 1015.0,
        "endTime": 1022.0,
        "transcript": "Una tua-i tekitarkaurtaqan pissuutekaa una yaaqsigluk' amna upyutaqluki.",
        "translation": "When the need for it was approaching, they would prepare them a long time beforehand."
    },
    "134": {
        "startTime": 1024.0,
        "endTime": 1031.0,
        "transcript": "Kiagmi maa-i iitaat can'get kelugkaqluki pitullruit.",
        "translation": "They also used to use tall cottongrass from the summer for weaving."
    },
    "135": {
        "startTime": 1032.0,
        "endTime": 1042.5,
        "transcript": "Arnat iitartaangaqameng tamakunek tua-i-llu nutaan saggluki waten apeqmeggnek nalacirluki.",
        "translation": "When women started gathering those tall cottongrass, they would spread them to dry, nalacirluki as they called it."
    },
    "136": {
        "startTime": 1043.0,
        "endTime": 1050.0,
        "transcript": "Tua-i-llu nutaan tamakunek piameng apeqmeggnek naliita, kinraki",
        "translation": "And then when those had dried, nalaluteng as they say,"
    },
    "137": {
        "startTime": 1052.5,
        "endTime": 1056.0,
        "transcript": "Quyurtevkenaki-am cali tupigturluki.",
        "translation": "They wouldn't gather them either, [but] weave them."
    },
    "138": {
        "startTime": 1058.5,
        "endTime": 1060.9,
        "transcript": "Nutaan-llu taqngamegteki imegluki.",
        "translation": "And then when they finished them, they would roll them up."
    },
    "139": {
        "startTime": 1061.0,
        "endTime": 1066.5,
        "transcript": "Tuaten pitullruit tamakut can'get kelugkait.",
        "translation": "That's what they used to do with grass that they used for weaving."
    },
    "140": {
        "startTime": 1068.0,
        "endTime": 1075.0,
        "transcript": "Au͡gkut ava-i wangkuta mat'um nalliini-w' tua-i umyuaqaqamki",
        "translation": "These days, when I think about those people back then"
    },
    "141": {
        "startTime": 1076.5,
        "endTime": 1082.0,
        "transcript": "Tua-i wiinga-llu tamana atullerkaa capeqsagulluku.",
        "translation": "I've started becoming daunted about leading that kind of life."
    },
    "142": {
        "startTime": 1085.0,
        "endTime": 1096.0,
        "transcript": "Tua-i-llu nutaan cali makut angutait makunek cali pissuutekameggnek",
        "translation": "And then when the men [worked on] their tools."
    },
    "143": {
        "startTime": 1097.0,
        "endTime": 1104.0,
        "transcript": "Makunek imarmiutarcuutekameggnek taluyinaurtut.",
        "translation": "They would make mink traps that looked like fish traps."
    },
    "144": {
        "startTime": 1106.5,
        "endTime": 1111.0,
        "transcript": "Mikluki tua-i, qaill' waten taktaurluki, qaillun-llu tua-i waten.",
        "translation": "They made them small, about this long, and something like this."
    },
    "145": {
        "startTime": 1111.5,
        "endTime": 1116.0,
        "transcript": "Kuiggaat-wa tua-i cuqluki taluyitullruut.",
        "translation": "They would make traps depending on the creeks."
    },
    "146": {
        "startTime": 1118.0,
        "endTime": 1123.5,
        "transcript": "Tamakut-am cali piciatun pivkenateng. Cuqerluteng cali.",
        "translation": "Those weren't made haphazardly either. They also had [set] measurements."
    },
    "147": {
        "startTime": 1125.0,
        "endTime": 1132.5,
        "transcript": "Makut-llu cali ilulirait waten can'giircuutetun ayuqevkenateng. Waten pinaurtut.",
        "translation": "Their inner compartments were not like blackfish traps either. They would be like this."
    },
    "148": {
        "startTime": 1133.0,
        "endTime": 1138.0,
        "transcript": "Tua-i-llu ingna igtetun ayuqeqerluni.",
        "translation": "And then that part over there would be like a den."
    },
    "149": {
        "startTime": 1140.0,
        "endTime": 1150.5,
        "transcript": "Au͡gna-wa alqerma uinga tayima waten tangvaurarqamni",
        "translation": "When I watched my older sister's husband like this"
    },
    "150": {
        "startTime": 1151.5,
        "endTime": 1159.0,
        "transcript": "Unatni tua-i waten piqerluki tauna tua-i cuq'errluku iteryararkaa",
        "translation": "He would do this with his hands to measure the entrance"
    },
    "151": {
        "startTime": 1159.5,
        "endTime": 1162.9,
        "transcript": "Wagg'uq igyaraat piqa'aqluku.",
        "translation": "Doing that to what they called the throat."
    },
    "152": {
        "startTime": 1163.0,
        "endTime": 1168.0,
        "transcript": "Tuaten ayuqetullruut. Piciatun pivkenateng.",
        "translation": "That's what they were like. They weren't haphazard."
    },
    "153": {
        "startTime": 1168.5,
        "endTime": 1173.0,
        "transcript": "Tuamtellu cali cuignilngurcuutnek cali taluyiami",
        "translation": "And then when he made otter traps like fish traps"
    },
    "154": {
        "startTime": 1174.0,
        "endTime": 1179.5,
        "transcript": "Tuamtellu igyarait waten ayuqluki au͡g'utun.",
        "translation": "Their entrances would be like this as before."
    },
    "155": {
        "startTime": 1180.5,
        "endTime": 1190.0,
        "transcript": "Tua-i-llu waten unatni cuq'errluku uumek kumluminek waten elliurluki neqututacirkiurluki.",
        "translation": "And then he would do this, measuring it with his thumb, determining the width like this."
    },
    "156": {
        "startTime": 1191.0,
        "endTime": 1199.0,
        "transcript": "Tuaten. Yaa, piciatun-am cali pivkenateng tamakut pitullrulliniut.",
        "translation": "Like that. Yes, they apparently didn't make those haphazardly either."
    },
    "157": {
        "startTime": 1201.5,
        "endTime": 1209.0,
        "transcript": "Tua-i mat'um nalliini-w' tua-i umyuaqaqamki au͡gkut",
        "translation": "These days, when I think about them back then"
    },
    "158": {
        "startTime": 1210.5,
        "endTime": 1215.6,
        "transcript": "Qaill'-wa tua-i yuullruciit piut.",
        "translation": "I wonder how their lives were."
    },
    "159": {
        "startTime": 1219.5,
        "endTime": 1224.0,
        "transcript": "Umyuaqaqamki caperqetullruanka.",
        "translation": "When I think of them, I would be daunted [by their lives]."
    },
    "160": {
        "startTime": 1225.0,
        "endTime": 1230.0,
        "transcript": "Tau͡gaam wiinga-w' tua-i Kass'angluki pillruama",
        "translation": "But because I [was born] when they started becoming Westernized"
    },
    "161": {
        "startTime": 1234.0,
        "endTime": 1238.9,
        "transcript": "Makut maa-i aulukesteput Kass'artaatullruut",
        "translation": "Our caretakers occasionally had Western things"
    },
    "162": {
        "startTime": 1241.0,
        "endTime": 1246.5,
        "transcript": "Tau͡gaam carugarnek unangeksaunateng.",
        "translation": "But they didn't get a lot."
    },
    "163": {
        "startTime": 1247.0,
        "endTime": 1260.0,
        "transcript": "Makut maa-i saayut, mukaaq, saarralaq, caqapigtaqameng-llu sugg'alinek cali piaqluteng.",
        "translation": "They would get tea, flour, sugar, and pilot bread once in a blue moon."
    },
    "164": {
        "startTime": 1262.0,
        "endTime": 1266.0,
        "transcript": "Tamakut tau͡gken tua-i unakek'ngait",
        "translation": "And yet those things that they got"
    },
    "165": {
        "startTime": 1267.5,
        "endTime": 1275.9,
        "transcript": "Tua-i itrutaqaceteng tepsaqnaurtut tua-i cakneq.",
        "translation": "They would smell very strong when they were brought in."
    },
    "166": {
        "startTime": 1276.0,
        "endTime": 1280.0,
        "transcript": "Imkut-llu makut mat'um nalliini tepailnguut.",
        "translation": "And they don't [seem to] have any scent these days."
    },
    "167": {
        "startTime": 1281.0,
        "endTime": 1291.0,
        "transcript": "Sugg'alit antaqaceteng yaaqsigluteng tepsaqnaurtut narniqpiarluteng, assirluteng.",
        "translation": "When they took out the pilot bread, they smell strong from afar, they smelled nice and delicious."
    },
    "168": {
        "startTime": 1293.0,
        "endTime": 1298.9,
        "transcript": "Maa-i mat'um nalliini waten caciirulluki wiinga piunga.",
        "translation": "These days, I can't [smell] them anymore."
    },
    "169": {
        "startTime": 1299.0,
        "endTime": 1304.0,
        "transcript": "Caqa'arqama tau͡gaam nar'aqluki tua-i canimetaqata.",
        "translation": "Once in a while, though, I smell them when they're close."
    },
    "170": {
        "startTime": 1307.0,
        "endTime": 1310.5,
        "transcript": "Au͡gkut ava-i tuaten ayuqellruut.",
        "translation": "That's what those people back then were like."
    },
    "171": {
        "startTime": 1312.0,
        "endTime": 1320.0,
        "transcript": "Qaillun-mi uksuarmi iciw' waten ayagaqata iciw' inerquutek'lallrit angutet?",
        "translation": "So, how about, you know, admonishments when the men, you know, when they traveled in the fall like this?"
    },
    "172": {
        "startTime": 1320.5,
        "endTime": 1336.0,
        "transcript": "Tua-llu, ii-i, waten ayagaaqameng inerquutektullruit waten aarnarqellrani.",
        "translation": "And so, yes, they used to admonish them like this when it was dangerous as they traveled."
    },
    "173": {
        "startTime": 1337.0,
        "endTime": 1344.0,
        "transcript": "Neplirasqevkenaki-llu cali yuilqumi pitullruit.",
        "translation": "They also used to tell them not to make a lot of noise in the wilderness."
    },
    "174": {
        "startTime": 1345.0,
        "endTime": 1346.9,
        "transcript": "Waten neplirasqevkenaki.",
        "translation": "They said not to make a lot of noise like this."
    },
    "175": {
        "startTime": 1347.0,
        "endTime": 1353.0,
        "transcript": "Tau͡gaam imkut arenqiallugtellriit",
        "translation": "Only those who get into accidents"
    },
    "176": {
        "startTime": 1354.0,
        "endTime": 1361.5,
        "transcript": "Tamaa-i tamakut kiskuneng tua-i nepliraarkauluteng.",
        "translation": "They must make noise if they have an fall into the water."
    },
    "177": {
        "startTime": 1367.0,
        "endTime": 1370.0,
        "transcript": "Inerquutekluki-am cali tamakut waten uksuarmi yuilqumi aarasqevkenata.",
        "translation": "They also admonished us against yelling in the wilderness in the fall like this."
    },
    "178": {
        "startTime": 1370.5,
        "endTime": 1372.5,
        "transcript": "Neplirasqevkenata.",
        "translation": "They told us not to make a lot of noise."
    },
    "179": {
        "startTime": 1376.0,
        "endTime": 1383.5,
        "transcript": "Tamakut-gguq tamaa-i tau͡gaam nanikualriit tuaten nepliratullruut.",
        "translation": "They said that only those in dire situations would make noise like that."
    },
    "180": {
        "startTime": 1384.0,
        "endTime": 1396.5,
        "transcript": "Tua-i-llu neplialriamek aaralriamek niiskuneng tua-i tauna taringarkauluku arenqiallugucia wall'u kis'ucia.",
        "translation": "And then if they heard anyone screaming, making noise, they would understand that [s]he's gotten into an accident or fell into water."
    },
    "181": {
        "startTime": 1398.0,
        "endTime": 1416.0,
        "transcript": "Tau͡gken mat'um nalliini tua-i inerquumananriameng-wa tua-i, inerqurnanriamceci wangkuta caciirulluteng.",
        "translation": "Yet because they are not admonished anymore these days, they don't know [those] anymore because we don't admonish youpl."
    },
    "182": {
        "startTime": 1417.0,
        "endTime": 1420.0,
        "transcript": "Waten-llu neplianaurtut.",
        "translation": "They also make noise like this."
    },
    "183": {
        "startTime": 1422.0,
        "endTime": 1427.0,
        "transcript": "Aaraaqluteng tua-i maani nunat akuliitni.",
        "translation": "They yell in between villages here."
    },
    "184": {
        "startTime": 1429.0,
        "endTime": 1431.0,
        "transcript": "Inerquutektullruit.",
        "translation": "They used to admonish against those."
    },
    "185": {
        "startTime": 1431.5,
        "endTime": 1441.5,
        "transcript": "Tua-i-llu ataucirqumek wiinga atullruaqa tamana arenqiallugtellria niitellemni.",
        "translation": "And then, I've done that once when I heard someone who got into an accident."
    },
    "186": {
        "startTime": 1443.0,
        "endTime": 1451.0,
        "transcript": "Ukut, ukut nunauruyuciat Tuntutuliarmiut akaurpailgan",
        "translation": "Before it was too long since Tuntutuliak was established as a village"
    },
    "187": {
        "startTime": 1455.0,
        "endTime": 1461.0,
        "transcript": "Kellirni kanani uitallemteńi, ukut-wa keluqliput cali.",
        "translation": "When we were down in Kelliq, with people inland from us too."
    },
    "188": {
        "startTime": 1463.0,
        "endTime": 1468.0,
        "transcript": "Una waniwa nanvaq mat'um enem ketiini tangrran.",
        "translation": "You see this lake toward the water from this house."
    },
    "189": {
        "startTime": 1470.5,
        "endTime": 1477.0,
        "transcript": "Waten erenrani atakuyartumi maaken kelumteńek aaralria.",
        "translation": "In the day nearing evening like this, I heard someone screaming inland from us."
    },
    "190": {
        "startTime": 1477.5,
        "endTime": 1480.0,
        "transcript": "Qang'a-ll' pingkuuyukanka.",
        "translation": "I had thought it was the people inland."
    },
    "191": {
        "startTime": 1481.0,
        "endTime": 1485.0,
        "transcript": "Cunaw' tua-i kit'ellria kanani. Kicaaqellinill'.",
        "translation": "It turned out that someone fell into the water down there. [S]he had apparently fell into the water."
    },
    "192": {
        "startTime": 1486.0,
        "endTime": 1494.0,
        "transcript": "Qerruniaranrakun iliita atralriit tanglliniluku",
        "translation": "One of the people going down apparently saw the person just as [s]he was going to freeze to death"
    },
    "193": {
        "startTime": 1496.0,
        "endTime": 1500.0,
        "transcript": "Man'a waten nunataitellrani.",
        "translation": "When there was no land here like this."
    },
    "194": {
        "startTime": 1502.0,
        "endTime": 1508.0,
        "transcript": "Cat inerquutait au͡gkut amllellruut.",
        "translation": "They had a lot of admonishments back then."
    },
    "195": {
        "startTime": 1509.0,
        "endTime": 1515.0,
        "transcript": "Waten au͡g'umek ava-i neplirasqevkenaku pitullruluki.",
        "translation": "They used to tell them like this not to make a lot of noise."
    },
    "196": {
        "startTime": 1516.0,
        "endTime": 1520.5,
        "transcript": "Tua-i-llu nutaan waten cali:",
        "translation": "And then this was especially important:"
    },
    "197": {
        "startTime": 1521.5,
        "endTime": 1535.0,
        "transcript": "Ayakata'arqameng cali qanerrlainarluteng tamatum nuniinun ayakatarniluteng.",
        "translation": "When they're going to travel, they would always say that they're going around that area."
    },
    "198": {
        "startTime": 1539.0,
        "endTime": 1553.0,
        "transcript": "Tua-i waten tekitenritaqata-llu tua-i arenqialluguciit nalluvkenaki piaqluki.",
        "translation": "And when they didn't return, they would know where they had accidents."
    },
    "199": {
        "startTime": 1557.0,
        "endTime": 1566.5,
        "transcript": "Tau͡gken mat'um nalliini waten ayagaaqameng maa-i angyatgun qanerpek'nateng.",
        "translation": "Yet these days, when they travel like this with these boats, they don't say anything."
    },
    "200": {
        "startTime": 1569.0,
        "endTime": 1578.0,
        "transcript": "Tua-i-llu tekitenrilameng, tekitenrilata qaill' tua-i ayuquciinaki qanenrilata.",
        "translation": "And then when they don't return, they don't know what happened to them because they didn't say anything."
    },
    "201": {
        "startTime": 1580.0,
        "endTime": 1585.0,
        "transcript": "Piciatun maa-i mat'um nalliini ayagangameng.",
        "translation": "It's because they've started traveling without consideration these days."
    },
    "202": {
        "startTime": 1585.5,
        "endTime": 1592.5,
        "transcript": "Wall'u natetmurrnguarluteng nunanun-ll' allanun ayagaqluteng.",
        "translation": "Or they pretend to go somewhere then travel to other villages."
    },
    "203": {
        "startTime": 1593.5,
        "endTime": 1600.0,
        "transcript": "Tamaa-i tamatum maa-i mat'um nalliini ayuquciirutetaitkut.",
        "translation": "That's what's making us so addled these days."
    },
    "204": {
        "startTime": 1602.0,
        "endTime": 1614.0,
        "transcript": "Qaillun tua-i ukut kingunrulriit waten ayuquciinaki piaqluki wall'u tuancukluki.",
        "translation": "They have no idea about these descendants like this or they think they're in some place."
    },
    "205": {
        "startTime": 1615.0,
        "endTime": 1625.0,
        "transcript": "Maa-i mat'um nalliini yuilqumi-llu tua-i tuqungraata qaillun ayuquciitaqluki.",
        "translation": "These days, even when they die in the wilderness, they have no idea about them."
    },
    "206": {
        "startTime": 1628.0,
        "endTime": 1637.0,
        "transcript": "Tang tua-i mat'um nalliini tua-i-wa waten caknernarqellriit amlleriameng",
        "translation": "You see, because there are now a lot of things bringing struggles these days"
    },
    "207": {
        "startTime": 1641.0,
        "endTime": 1648.0,
        "transcript": "Maa-i waten au͡gkut ayuqellrunritut, waten.",
        "translation": "People back then were not like this, like this."
    },
    "208": {
        "startTime": 1649.5,
        "endTime": 1654.0,
        "transcript": "Tua-i ca murilkerrlainarluku.",
        "translation": "They always observed everything."
    },
    "209": {
        "startTime": 1654.5,
        "endTime": 1663.7,
        "transcript": "Uksuarmi-llu wangkuta cali tan'gaurlurni waten qalaruquratullruitkut",
        "translation": "And in the fall, they would always talk to us boys like this"
    },
    "210": {
        "startTime": 1664.0,
        "endTime": 1670.5,
        "transcript": "Ciunerkamteńek, tekitarkamteńek ellmeng atuqemeggnek.",
        "translation": "About our futures, what's in store for us, that they are experiencing."
    },
    "211": {
        "startTime": 1672.0,
        "endTime": 1676.0,
        "transcript": "Aarnarqellriit apertualuki, yuilqumi-llu.",
        "translation": "They would indicate what was dangerous, in the wilderness too."
    },
    "212": {
        "startTime": 1680.0,
        "endTime": 1688.0,
        "transcript": "Cat, cat-llu maani nunam qaingani pengurraat qerturalriit aterluteng.",
        "translation": "These things on land, elevated hills, had names."
    },
    "213": {
        "startTime": 1688.5,
        "endTime": 1691.0,
        "transcript": "Kuiggaat-llu tamarmeng aterluteng.",
        "translation": "All of the creeks had names too."
    },
    "214": {
        "startTime": 1692.0,
        "endTime": 1694.8,
        "transcript": "Nanvat-ll' ilait cali aterluteng.",
        "translation": "Some of the lakes had names too."
    },
    "215": {
        "startTime": 1696.5,
        "endTime": 1702.0,
        "transcript": "Tua-i nalluvkenaku man'a nunam qainga.",
        "translation": "They knew the layout of this land."
    },
    "216": {
        "startTime": 1702.5,
        "endTime": 1712.0,
        "transcript": "Tau͡gken mat'um nalliini makut maa-i yup'ut apertuatnanriamteki",
        "translation": "Yet these days, because we don't point those out to our children"
    },
    "217": {
        "startTime": 1714.0,
        "endTime": 1724.0,
        "transcript": "Mat'umek yuilqumek cat-llu nallungluki, kuiget-llu, nanvat-llu, qertulriit-llu makut.",
        "translation": "They don't know the wilderness or what's on it, rivers, and lakes, and these elevated areas."
    },
    "218": {
        "startTime": 1729.5,
        "endTime": 1739.0,
        "transcript": "Camek-llu tua-i piaqata apcaaqellriani cam nuniini camek piciitnek",
        "translation": "And when something happens, when we ask them where it happened to them"
    },
    "219": {
        "startTime": 1740.0,
        "endTime": 1748.5,
        "transcript": "Wall'u yuk tauna waten maa-i mat'um nalliini tamarilalriit, tamalalriit.",
        "translation": "Or a person these days would get lost, they get lost."
    },
    "220": {
        "startTime": 1751.0,
        "endTime": 1763.5,
        "transcript": "Tauna, tauna tangertellra apcaaqellriani cam nuniini tangellrucianek atra-llu nalluluku.",
        "translation": "When they ask the people who saw it about the area where they saw it they don't know its name either."
    },
    "221": {
        "startTime": 1764.0,
        "endTime": 1772.5,
        "transcript": "Taum-gguq avaniirluteng tau͡gaam pinaurtut apertuatnanriamceteng.",
        "translation": "They would say it happened over there because we don't point those out to them anymore."
    },
    "222": {
        "startTime": 1774.0,
        "endTime": 1781.5,
        "transcript": "Ca tamalkuan wangkuta qalaruyutek'lallruyaaqaput aturrlainarpek'naki tau͡gaam.",
        "translation": "We used to talk about everything, but we didn't always experience them."
    },
    "223": {
        "startTime": 1783.0,
        "endTime": 1786.5,
        "transcript": "Tau͡gaam tekitaqamteki elitaqaqluki.",
        "translation": "But when we reached them, we would recognize them."
    },
    "224": {
        "startTime": 1789.0,
        "endTime": 1797.0,
        "transcript": "Yaa, qanruyutekun tau͡gaam yuk yuugarkauyaaqelliniami.",
        "translation": "Yes, a person should live through traditional wisdom."
    },
    "225": {
        "startTime": 1797.5,
        "endTime": 1804.0,
        "transcript": "Yaa, qanruyun atunrilkuniu elluarrluni yuungaitelliniuq.",
        "translation": "Yes, [s]he evidently will not live well if [s]he does not adhere to traditional wisdom."
    },
    "226": {
        "startTime": 1805.0,
        "endTime": 1809.5,
        "transcript": "Ilaminek-llu waten nuqlilluni calrianek.",
        "translation": "[S]he will also lack what their peers work on."
    },
    "227": {
        "startTime": 1812.0,
        "endTime": 1815.0,
        "transcript": "Waten au͡gkut qalarutetullruitkut:",
        "translation": "They used to tell us this back then:"
    },
    "228": {
        "startTime": 1816.0,
        "endTime": 1825.0,
        "transcript": "Man'a-gguq qanruyun atuqumteggu, maligtaquluku-llu yuukumta elluarrluta yuugarkaugukut.",
        "translation": "If we adhere to this traditional wisdom, obey it while we live we will live well."
    },
    "229": {
        "startTime": 1825.5,
        "endTime": 1829.5,
        "transcript": "Qessalertevkenata, qavaarpek'nata.",
        "translation": "We should not be lazy or sleep too much."
    },
    "230": {
        "startTime": 1833.5,
        "endTime": 1836.5,
        "transcript": "Tuaten tua-i akeqnauraitkut.",
        "translation": "They would promise us that."
    },
    "231": {
        "startTime": 1839.0,
        "endTime": 1849.5,
        "transcript": "Tau͡gken tua-i, yaa, taman' apertuallrat tekiteksaunaku.",
        "translation": "However, yes, we wouldn't reach what they indicated yet."
    },
    "232": {
        "startTime": 1849.6,
        "endTime": 1854.5,
        "transcript": "Tau͡gaam tekitaqamteggu maa-i mat'um nalliini elitaqaqluku.",
        "translation": "But when we reach it these days, we recognize it."
    },
    "233": {
        "startTime": 1855.5,
        "endTime": 1860.5,
        "transcript": "Taumek au͡gkut waten qalarutlallrukaitkut:",
        "translation": "That's why they used to tell us this back then:"
    },
    "234": {
        "startTime": 1863.0,
        "endTime": 1872.5,
        "transcript": "Una-gguq qalarutestevvut murilkelluku, yaa, tangvaurqilarput qanra.",
        "translation": "They said to pay attention to our instructor yes, we should watch his mouth."
    },
    "235": {
        "startTime": 1874.5,
        "endTime": 1882.0,
        "transcript": "Atam-gguq uluqaqumteggu imna qalartellra uunguciirrniar[tukut].",
        "translation": "They said that if we look away from him, [we] won't know what he's talking about anymore."
    }
};